import { useMsal } from "@azure/msal-react";

export const useAuth = () => {
  const { accounts } = useMsal();
  const isLoggedIn = accounts.length > 0;

  if (!isLoggedIn) {
    return { isLoggedIn: !isLoggedIn };
  }

  const loginUser = accounts[0];

  return {
    isLoggedIn,
    loginUser,
  };
};
